type ScannerPreferenceUser = {
    id?: number | null;
    auth0Id?: string | null;
    email?: string | null;
} | null | undefined;

const QR_CAMERA_SCANNER_ENABLED_PREFIX = "qrCameraScannerEnabled";
export const QR_CAMERA_SCANNER_PREFERENCE_CHANGED_EVENT = "qr-camera-scanner-preference-changed";

export function isQrCameraScannerEnabledForUser(user: ScannerPreferenceUser) {
    if (typeof window === "undefined") {
        return true;
    }

    const storedValue = window.localStorage.getItem(getQrCameraScannerStorageKey(user));
    return storedValue !== "false";
}

export function setQrCameraScannerEnabledForUser(user: ScannerPreferenceUser, isEnabled: boolean) {
    if (typeof window === "undefined") {
        return;
    }

    window.localStorage.setItem(getQrCameraScannerStorageKey(user), String(isEnabled));
    window.dispatchEvent(new CustomEvent(QR_CAMERA_SCANNER_PREFERENCE_CHANGED_EVENT, {
        detail: {isEnabled}
    }));
}

function getQrCameraScannerStorageKey(user: ScannerPreferenceUser) {
    const userKey = user?.id
        ? `id:${user.id}`
        : user?.auth0Id
            ? `auth0:${user.auth0Id}`
            : user?.email
                ? `email:${user.email}`
                : "anonymous";

    return `${QR_CAMERA_SCANNER_ENABLED_PREFIX}:${userKey}`;
}
